import { TRACKING } from 'common/constants/constants';
import * as TrackingService from 'common/services/tracking.service';
import {
  StyledButtonContainer,
  StyledContentWrapper,
  StyledHeader
} from './ConfirmAccountCreation.style';
import { useCallback, useContext } from 'react';
import { GitProviderSelectContext } from './GitProviderSelect.context';
import { LBButton } from '@linearb/buzz';

interface ConfirmAccountCreationProps {
  onSendInvite: () => void;
}

export function ConfirmAccountCreation({
  onSendInvite
}: ConfirmAccountCreationProps) {
  const { setConfirmFamiliarOrgCreation, familiarOrgName: orgname } =
    useContext(GitProviderSelectContext);

  const onCreateAccount = useCallback(() => {
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.ONBOARDING,
      page_tab: TRACKING.PAGE_TABS.YOU_LOOK_FAMILIAR,
      click_type: TRACKING.CLICK.STRAY_ORG_CREATE_NEW_ORG_CONFIRM
    });

    setConfirmFamiliarOrgCreation(true);
  }, []);

  return (
    <StyledContentWrapper data-testid='confirm-account-creation'>
      <StyledHeader variant='h5'>Are you sure?</StyledHeader>
      <p>
        You probably don't want to create a new organization, as your email
        domain and Git provider data are already connected to an existing
        LinearB company account named <strong>{orgname}</strong>.
      </p>

      <StyledButtonContainer>
        <div className='flex flex-row gap-2 justify-center'>
          <LBButton onClick={onSendInvite}>
            <span className='uppercase'>Ask Admin for Invite</span>
          </LBButton>
          <LBButton variant='outline' onClick={onCreateAccount}>
            Continue with a new organization
          </LBButton>
        </div>
      </StyledButtonContainer>
    </StyledContentWrapper>
  );
}
